import React from 'react';
import { Box } from '@mui/material';

// Isotipo de la marca VitaNotas — ficha clínica (hoja con esquina doblada,
// el ícono universal de "documento") con un pulso (ECG) adentro en vez de
// renglones de texto: junta las dos mitades del nombre ("Vita" = pulso,
// "Notas" = ficha) en un solo símbolo. Un solo lugar para el SVG del logo,
// reusado en Login/Home/Layout — un cambio de marca futuro se edita acá una
// sola vez en vez de en cada pantalla por separado.
const BrandMark = ({ size = 24, variant = 'solid', sx, ...props }) => {
  // 'bare': sin squircle de fondo, solo el trazo blanco — para usar sobre un
  // fondo azul propio ya existente (AppBar, panel de Login, hero de Home).
  // El chip semitransparente que existía antes ('ghost') se sacó: con la
  // ficha (más área de trazo blanco que el pulso original) se veía como un
  // rectángulo gris turbio por la poca diferencia de tono contra el fondo
  // azul, en cualquier tamaño — reportado por el usuario tanto en el hero
  // grande de Home como en el panel chico de Login.
  const isBare = variant === 'bare';
  return (
    <Box
      component="svg"
      viewBox="0 0 48 48"
      fill="none"
      sx={{ width: size, height: size, flexShrink: 0, ...sx }}
      {...props}
    >
      {!isBare && (
        <rect x="3" y="3" width="42" height="42" rx="12" fill="#1565c0" />
      )}
      <path
        d="M14 37.5V12.5a2 2 0 0 1 2-2h11.5l6.5 6.5v20.5a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2Z"
        stroke="#fff"
        strokeWidth="2.3"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 10.5v5.2a1.3 1.3 0 0 0 1.3 1.3h5.2"
        stroke="#fff"
        strokeWidth="2.3"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 25.5h3l1.7-5 2.9 10 1.7-7 1.1 2h5.9"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Box>
  );
};

export default BrandMark;
